// extracted by mini-css-extract-plugin
module.exports = {"content":"statistic-popover-title_content__3QFSK"};